/**
 * Romanian UI labels for UiBlock components
 */
export const LABELS = {
  PRICE_SUFFIX: 'cu TVA',
  MSRP_PREFIX: 'PRP:',
  ADD_TO_CART: 'Adauga in cos',
  VIEW_DETAILS: 'Vezi detalii',
  ADD_TO_WISHLIST: 'Adauga la favorite',
  REMOVE_FROM_WISHLIST: 'Sterge de la favorite',
  OUT_OF_STOCK: 'La comanda',
  DISCONTINUED: 'Produsul nu mai este disponibil',
  NOT_FOR_SALE: 'Produsul nu se mai comercializeaza',
  REWARD_POINTS_SUFFIX: 'puncte bonus',
  CURRENCY: 'Lei',
} as const
